import styled from '@emotion/styled';
import { Card, theme } from '@kindur/components';
import React from 'react';
import withTracking from '../../components/Common/withTracking';
import healthIcon from '../../images/home/health.svg';
import walletIcon from '../../images/home/wallet.svg';
import ThreeColumn from '../Common/ThreeColumnAlt';

const Title = styled('h2')`
  font-family: 'DM Sans', sans-serif;
  letter-spacing: 0.2px;
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.5rem;
  max-width: 10em;
`;

const BulletPoint = styled(Card)`
  max-width: 20em;

  ${theme.breakpoints.tabletDown} {
    margin-bottom: 24px;
    .-copy-container div {
      margin-bottom: 24px;
    }
  }
  .-body-container {
    margin-left: 36px;
  }
  .-copy-container div {
    font-family: 'DM Sans', sans-serif;
    font-size: 18px;
    letter-spacing: -0.2px;
    line-height: 26px;
    padding-left: 16px;
    margin-bottom: 0;
    margin-top: 0;
    b {
      font-weight: 700;
    }
  }
`;

const Container = styled('div')`
  padding: 4rem 1.5rem;
`;

const TrackComponentName = `BeInTheKnow`;

const BeInTheKnow = ({ content, track }) => {
  return (
    <Container>
      <ThreeColumn>
        <Title>{content.title}</Title>
        <BulletPoint
          bullet={true}
          icon={<img alt={`health`} src={healthIcon} width={'30px'} height={'39px'} />}
          copy={content.bullets[0]}
        />
        <BulletPoint
          bullet={true}
          icon={<img alt={`wallet`} src={walletIcon} width={'38px'} height={'31px'} />}
          copy={content.bullets[1]}
        />
      </ThreeColumn>
    </Container>
  );
};

BeInTheKnow.displayName = TrackComponentName;

export default withTracking(BeInTheKnow);
